module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/website-example-68e7b836dd6f8f4ad94bdf0043250320.webp";